// Matrice d'accès par rôle — miroir de shared.py (ROLE_MODULES) pour le masquage UI.
// La sécurité réelle est appliquée côté serveur ; ici on ne pilote que l'affichage.
export const ROLE_MODULES = {
  admin: ["dashboard", "clients", "missions", "time", "letters", "programs", "lcbft", "qc", "accounting", "echeances", "users"],
  expert: ["dashboard", "clients", "missions", "time", "letters", "programs", "lcbft", "qc", "accounting", "echeances", "users"],
  collab_fr: ["dashboard", "clients", "missions", "time", "letters", "programs", "lcbft", "qc"],
  collab_cm: ["dashboard", "clients", "missions", "time", "qc", "accounting", "echeances"],
};

export const canAccess = (role, module) => (ROLE_MODULES[role] || []).includes(module);

export const canViewPayroll = (role) => role === "admin" || role === "expert";
